import { Country } from '~/Api/Country';
import { ApiClientError } from '~/ApiClient';

import { Error, ErrorCode } from './Error';

export const mapError = (error: ApiClientError): Error => {
	const errorCode = error.code as ErrorCode;
	const { duplicateCountries, product, productGroup } = (error.meta ?? {}) as {
		duplicateCountries?: { alpha2: string; name: string }[];
		product?: { id: string };
		productGroup?: { id: string };
	};

	return new Error(
		errorCode,
		product?.id ?? null,
		productGroup?.id ?? null,
		duplicateCountries?.map((country) => new Country(country.alpha2, country.name)) ?? []
	);
};
